export const modal = {
  modifyTitle: "MODIFICA PRENOTAZIONE",
  createTitle: "CREA PRENOTAZIONE",
  modifyAction: "Modifica prenotazione",
  createAction: "Crea prenotazione",
  processing: "Elaborazione della prenotazione...",

  selectRoomType: "Seleziona il tipo di camera",
  selectAccommodation: "Seleziona un alloggio",

  quantity: "Quantità",
  arrival: "Arrivo",
  departure: "Partenza",
  guestName: "Nome dell'ospite",
  email: "Email",
  phone: "Telefono",
  guestsNumber: "Numero di ospiti",
  price: "Prezzo",
  cancel: "Annulla",

  noTemplateSummary: "Nessun modello attivo",
  noTemplateDetail: "Nessun modello disponibile",

  limitReachedSummary: "Limite raggiunto",
  limitPromotionDetail: "Non puoi aggiungere più di 1 promozione",
  limitTaxDetail: "Non puoi aggiungere più di 1 imposta",

  validations: {
    fillRequired: "Completa tutti i campi obbligatori.",
    phoneMin: "Il numero di telefono deve avere almeno 5 cifre.",
    selectDates: "Seleziona le date di arrivo e di partenza.",
    guestsMin: "Il numero di ospiti deve essere almeno 1.",
    priceNegative: "Il prezzo non può essere negativo.",
  },
};

export default modal;
